<script lang="ts">
  import { onMount } from "svelte";

  import playIcon from "./assets/play.svg?raw";
  import stopIcon from "./assets/stop.svg?raw";
  import closeIcon from "./assets/close.svg?raw";

  import SoundCardTitle from "./SoundCardTitle.svelte";
  import Attribution from "./Attribution.svelte";

  import { soundBoard } from "./store";
  import { fetchAttribution, showToastWrapper, unlinkSound } from "./global";
  import { stopPropagation } from "./genericHandlers";
  import { Howl } from "howler";
  import type { SoundCard } from "./SoundCard";
  import { getOrCreateSoundCache, SoundCache } from "./lib/soundCache";

  export let card: SoundCard;
  export let scene;
  export let closeable = true;
  export let nameChangeCallback;

  let audio: Howl | null = null;
  let soundCache: SoundCache = null;

  $: if (audio && scene) {
    const curVolume = 100;
    const sceneVolumeMod = scene.globalVolume / 100;
    audio.volume((curVolume * sceneVolumeMod) / 100);
  }

  let playing = false;

  let attribution = null;
  onMount(async () => {
    soundCache = await getOrCreateSoundCache();
    audio = new Howl({
      src: [await soundCache.fetchSound(card.sound)],
      html5: true,
      loop: false,
      format: [card.sound.html_data_type],
      onend: () => {stop()},
    });

    fetchAttribution(card.sound.id, (att) => (attribution = att)); // Might be null if there is no attribution
    audio.volume(100);
  });

  export function stop() {
    if (audio === null) {
      return;
    }
    // @ts-ignore
    audio.stop();
    playing = false;
  }

  function play() {
    if (audio === null) {
      return;
    }
    // @ts-ignore
    audio.play();
    playing = true;
  }

  const handleNameChangeRequest = (newName) => {
    if (nameChangeCallback) {
      nameChangeCallback(scene.id, card.id, newName);
    }
  };

  const deleteCard = () => {
    // @ts-ignore
    stop();
    soundBoard.DeleteCard(scene.id, card["id"]);
    const soundId = card["sound"].id;
    unlinkSound(soundId, $soundBoard);
  };
</script>

<div
  class="soundcard soundcard-effect-dimensions soundcard-effect-container {playing
    ? ''
    : 'soundcard-off'} editable-icon"
>
  {#if closeable}
    <button
      class="hover-target soundcard-close-button"
      tabindex="0"
      aria-label="remove card"
      on:click={deleteCard}
      on:pointerdown={stopPropagation}
      on:mousedown={stopPropagation}
    >
      {@html closeIcon}
    </button>
  {/if}
  <div class="soundcard-header">
    <SoundCardTitle {card} nameChangeCallback={handleNameChangeRequest} />
    {#if attribution}
      <Attribution {attribution} isUserSound={false} />
    {/if}
  </div>
  <div on:pointerdown={stopPropagation} on:mousedown={stopPropagation}>
    {#if playing}
      <button
        id="stop-{card['id']}"
        class="soundcard-button dark"
        type="button"
        on:click={stop}
      >
        {@html stopIcon}
      </button>
    {:else}
      <button
        id="play-{card['id']}"
        class="soundcard-button dark"
        type="button"
        on:click={play}
      >
        {@html playIcon}
      </button>
    {/if}
  </div>
</div>
